import shouldShowProgressIndicator from '../utils/shouldShowProgressIndicator';
import { observer } from 'mobx-react-lite';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import * as React from 'react';

export interface ProgressIndicatorProps {
    attachmentViewState: AttachmentFullViewState;
}

const styles = require('./AttachmentProgressIndicator.scss');

const AttachmentProgressIndicator = observer(function AttachmentProgressIndicator(
    props: ProgressIndicatorProps
) {
    return (
        shouldShowProgressIndicator(props.attachmentViewState) && (
            <span className={styles.progressIndicator}>
                <ProgressIndicator
                    percentComplete={props.attachmentViewState.actionCompletePercent}
                />
            </span>
        )
    );
});
export default AttachmentProgressIndicator;
